import { AxiosInstance } from 'axios';
import {
  RoleDeleteRequest,
  RoleFindEmployeesRequest,
  RoleRepository,
} from '@/model/repository/manager/role/RoleRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): RoleRepository => ({
    delete(request: RoleDeleteRequest) {
      return Repository.delete(`${resource}/${request.roleId}`);
    },
    findEmployees(request: RoleFindEmployeesRequest) {
      return Repository.get(`${resource}/${request.roleId}/employees`);
    },
  });
